import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";
import { ArrowLeft, Loader2, MailCheck, Send } from "lucide-react";
import { formatApiError } from "@/lib/formatApiError";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.forgotPassword(email);
      setSent(true);
    } catch (error) {
      toast.error(formatApiError(error, "Erreur lors de l'envoi"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-background">
      <Card className="w-full max-w-md" data-testid="forgot-password-card">
        <CardHeader className="space-y-2 text-center">
          <img src="/logo-bati-assistant.svg" alt="Bati Assistant" className="mx-auto h-16 w-16 mb-2" />
          <CardTitle className="font-heading text-2xl">Mot de passe oublié</CardTitle>
          <CardDescription>
            Saisissez votre email : nous vous enverrons un lien pour choisir un nouveau mot de passe.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          {sent ? (
            <div className="rounded-md border bg-muted/40 p-4 text-sm flex gap-3" data-testid="forgot-password-sent">
              <MailCheck className="h-5 w-5 text-primary shrink-0" />
              <p>
                Si un compte existe pour <strong>{email}</strong>, un email vient d'être envoyé.
                Le lien est valable <strong>1 heure</strong>. Pensez à vérifier vos spams.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="space-y-2">
                <Label htmlFor="forgot-email">Email</Label>
                <Input
                  id="forgot-email"
                  type="email"
                  placeholder="votre@email.fr"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="h-11"
                  data-testid="forgot-password-email-input"
                />
              </div>
              <Button type="submit" className="w-full h-11" disabled={loading} data-testid="forgot-password-submit-btn">
                {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Send className="h-4 w-4 mr-2" />}
                Envoyer le lien
              </Button>
            </form>
          )}
          <Link
            to="/login"
            className="flex items-center justify-center gap-1 text-sm text-muted-foreground hover:text-foreground"
            data-testid="forgot-password-back-link"
          >
            <ArrowLeft className="h-4 w-4" /> Retour à la connexion
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
